/* Brewskin 2026 redesign — behaviour for header, panels, product page, bag drawer and bag page.
   Cart model (same as the published theme): the badge and the drawer only ever show what
   Shopify's response says — nothing is guessed client-side. Every press is acknowledged in the
   same frame with a pending state (dissolve on the pill, dim on the bag line), and the confirm
   animation + count pop fire when the server replies. Mutations run one at a time, in click
   order, so responses can never land out of order. Quick-adds confirm against a micro section
   (bs-count, just the item count) and the drawer is re-rendered right behind on the same chain,
   so the confirmation never waits on the full drawer render.
   Buy now / Pre-order now buys that item only: the bag is cleared, the item added, and the
   hidden name="checkout" button is pressed so Razorpay Magic Checkout intercepts it exactly
   like bag → Checkout (and the plain /cart post is the fallback when Magic isn't there). */
(function () {
  'use strict';
  var d = document;
  var $ = function (s, r) { return (r || d).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || d).querySelectorAll(s)); };
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var isDesk = function () { return window.innerWidth >= 990; };
  var inr = function (cents) { return '₹' + (cents / 100).toLocaleString('en-IN', { maximumFractionDigits: 2 }); };

  /* ---------- Announcement marquee ---------- */
  function marquee() {
    $$('[data-bs-marquee]').forEach(function (el) {
      var tr = $('[data-bs-track]', el);
      if (!tr || reduce || typeof tr.animate !== 'function') return;
      var secs = (parseFloat(el.dataset.speed) || 45) * (isDesk() ? 1 : 0.78);
      var a = tr.animate([{ transform: 'translateX(0)' }, { transform: 'translateX(-50%)' }], { duration: secs * 1000, iterations: Infinity, easing: 'linear' });
      ['mouseenter', 'focusin'].forEach(function (ev) { el.addEventListener(ev, function () { a.pause(); }); });
      ['mouseleave', 'focusout'].forEach(function (ev) { el.addEventListener(ev, function () { a.play(); }); });
    });
  }

  /* ---------- Header: compact on scroll, measured heights ---------- */
  function header() {
    var hd = $('[data-bs-header]');
    if (!hd) return;
    var compact = false;
    var onScroll = function () {
      var c = (window.scrollY || 0) > 60;
      if (c !== compact) { compact = c; hd.classList.toggle('is-compact', c); }
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    var ann = $('.bs-ann');
    var set = function () {
      var r = d.documentElement.style;
      if (ann) r.setProperty('--bs-ann-h', ann.offsetHeight + 'px');
      r.setProperty('--bs-hd-h', hd.offsetHeight + 'px');
    };
    set();
    if ('ResizeObserver' in window) new ResizeObserver(set).observe(hd);
    else window.addEventListener('resize', set);
  }

  /* ---------- Footer columns: open on desktop, accordions on mobile ---------- */
  function footer() {
    var cols = $$('[data-bs-ftcol]');
    if (!cols.length) return;
    var last = null;
    var sync = function () {
      var desk = isDesk();
      if (desk === last) return;
      last = desk;
      cols.forEach(function (c) { if (desk) c.setAttribute('open', ''); else c.removeAttribute('open'); });
    };
    sync();
    window.addEventListener('resize', sync);
  }

  /* ---------- Overlay + drawers ---------- */
  var ov = null, openName = null, lastFocus = null;
  function open(name) {
    ov = ov || $('[data-bs-ov]');
    if (!ov) return false;
    if (!openName) lastFocus = d.activeElement;
    $$('[data-bs-drawer]', ov).forEach(function (dr) {
      var on = dr.dataset.bsDrawer === name;
      dr.classList.toggle('is-open', on);
      dr.setAttribute('aria-hidden', on ? 'false' : 'true');
      if (on) dr.removeAttribute('inert'); else dr.setAttribute('inert', '');
    });
    ov.classList.add('is-open');
    d.body.classList.add('bs-lock');
    openName = name;
    setTimeout(function () {
      var dr = $('[data-bs-drawer="' + name + '"]', ov);
      var f = dr && $('[data-bs-close]', dr);
      if (f) f.focus({ preventScroll: true });
    }, 80);
    return true;
  }
  function close() {
    ov = ov || $('[data-bs-ov]');
    if (!ov || !openName) return;
    $$('[data-bs-drawer]', ov).forEach(function (dr) {
      dr.classList.remove('is-open');
      dr.setAttribute('aria-hidden', 'true');
      dr.setAttribute('inert', '');
    });
    ov.classList.remove('is-open');
    d.body.classList.remove('bs-lock');
    openName = null;
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }
  function openPanel(key) {
    ov = ov || $('[data-bs-ov]');
    /* Panel content is either a <template> or hidden HTML in the page (readable by search engines). */
    var src = $('[data-bs-tpl="' + key + '"]');
    if (!ov || !src) return;
    $('[data-bs-panel-title]', ov).textContent = src.dataset.title || '';
    var body = $('[data-bs-panel-body]', ov);
    body.innerHTML = '';
    if (src.content) body.appendChild(src.content.cloneNode(true));
    else Array.prototype.forEach.call(src.childNodes, function (n) { body.appendChild(n.cloneNode(true)); });
    body.scrollTop = 0;
    open('panel');
  }
  function trapTab(e) {
    if (!openName || e.key !== 'Tab') return;
    var dr = $('[data-bs-drawer="' + openName + '"]');
    if (!dr) return;
    var f = $$('a[href], button:not([disabled]), input, [tabindex]:not([tabindex="-1"])', dr).filter(function (x) { return x.offsetParent !== null; });
    if (!f.length) return;
    var first = f[0], lastEl = f[f.length - 1];
    if (e.shiftKey && d.activeElement === first) { e.preventDefault(); lastEl.focus(); }
    else if (!e.shiftKey && d.activeElement === lastEl) { e.preventDefault(); first.focus(); }
  }

  /* ---------- Cart (Ajax API + Section Rendering API) ---------- */
  var chain = Promise.resolve();
  function cartOp(path, body, secs) {
    var p = chain.then(function () { return cartReq(path, body, secs); });
    chain = p.then(null, function () {});
    return p;
  }
  function queueRefresh() {
    chain = chain.then(function () { return refreshBag(); });
  }
  function sectionIds() {
    var s = ['bs-bag'];
    if ($('[data-bs-cart-body]')) s.push('bs-cart-body');
    return s;
  }
  function parse(html, sel) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    return doc.querySelector(sel);
  }
  function render(sections) {
    if (!sections) return;
    if (sections['bs-count']) {
      var k = parse(sections['bs-count'], '[data-bs-count-src]');
      if (k) setCount(k.dataset.count);
    }
    if (sections['bs-bag']) {
      var n = parse(sections['bs-bag'], '[data-bs-bag]');
      var holder = $('[data-bs-bag-root]');
      if (n && holder) { holder.innerHTML = ''; holder.appendChild(n); }
      if (n) setCount(n.dataset.count);
    }
    if (sections['bs-cart-body']) {
      var c = parse(sections['bs-cart-body'], '[data-bs-cart-body]');
      var cur = $('[data-bs-cart-body]');
      if (c && cur) { cur.replaceWith(c); stickyBar(); }
    }
  }
  function setCount(n) {
    $$('[data-bs-count]').forEach(function (el) { el.textContent = n; });
    var zero = !Number(n);
    $$('.bs-hd__dot').forEach(function (el) { el.classList.toggle('bs-zero', zero); });
  }
  function note(msg) {
    $$('[data-bs-note]').forEach(function (el) {
      if (msg) { el.textContent = msg; el.hidden = false; } else { el.hidden = true; }
    });
  }
  function cartReq(path, body, secs) {
    body = body || {};
    body.sections = secs || sectionIds();
    body.sections_url = window.location.pathname;
    return fetch(root + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (j) {
        if (!r.ok || j.status === 422 || j.status === 'bad_request') {
          var err = new Error(j.description || j.message || 'Something went wrong. Please try again.');
          err.data = j;
          throw err;
        }
        render(j.sections);
        return j;
      });
    });
  }
  function refreshBag() {
    return fetch(root + '?sections=' + sectionIds().join(','), { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(render)
      .catch(function () {});
  }
  function busy(el, fn) {
    var box = (el && el.closest('.bs-bag, .bs-cart__body')) || el;
    if (box) box.classList.add('is-busy');
    return Promise.resolve().then(fn).catch(function (err) {
      note(err && err.message ? err.message : 'Something went wrong. Please try again.');
    }).then(function () { if (box) box.classList.remove('is-busy'); });
  }
  function addToBag(el, variant, qty, name, props) {
    /* The drawer opens on the press itself and shows the bag's current, true contents;
       the new line appears when Shopify confirms it. */
    open('bag');
    var box = $('[data-bs-bag]') || el;
    return busy(box, function () {
      var item = { id: Number(variant), quantity: qty };
      if (props) item.properties = props;
      return cartOp('cart/add.js', { items: [item] }).then(function () {
        note((name || 'Item') + ' added to your bag.');
      });
    });
  }

  /* ---------- Buy now / Pre-order now: this item only ----------
     The bag is cleared, the pressed item is added, and then a hidden name="checkout"
     button (injected at init, same classes as the bag's Checkout button) is clicked —
     the exact same press as bag → Checkout — so Razorpay Magic Checkout intercepts it
     the way it does for the bag. If Magic isn't running, that button's form posts to
     /cart with name="checkout" and Shopify sends the customer to checkout as normal,
     so the flow degrades to the standard one instead of breaking. If the add fails
     after the clear (e.g. the item sold out this second), the previous bag contents
     are put back exactly as they were and the bag opens with the message. */
  function ensureCheckoutForm() {
    if (!$('[data-bs-buynow]') || $('[data-bs-buynow-checkout]')) return;
    var f = d.createElement('form');
    f.action = root + 'cart';
    f.method = 'post';
    f.setAttribute('aria-hidden', 'true');
    f.style.cssText = 'position:absolute;left:-9999px;top:0;width:1px;height:1px;overflow:hidden;';
    var b = d.createElement('button');
    b.type = 'submit';
    b.name = 'checkout';
    b.tabIndex = -1;
    b.className = 'cart__checkout-button razorpay-trigger';
    b.setAttribute('data-bs-buynow-checkout', '');
    b.textContent = 'Checkout';
    f.appendChild(b);
    d.body.appendChild(f);
  }
  function formProps(sec) {
    var props = null;
    if (!sec) return null;
    $$('.bs-pdp__form [name^="properties["]', sec).forEach(function (inp) {
      var m = inp.name.match(/^properties\[(.+)\]$/);
      if (!m || inp.disabled) return;
      if ((inp.type === 'checkbox' || inp.type === 'radio') && !inp.checked) return;
      props = props || {};
      props[m[1]] = inp.value;
    });
    return props;
  }
  function goCheckout() {
    var btn = $('[data-bs-buynow-checkout]');
    if (btn) btn.click();
    else window.location.href = root + 'checkout';
  }
  function buyNow(el, variant, qty, props) {
    if (el.classList.contains('is-busy')) return;
    el.classList.add('is-busy');
    el.disabled = true;
    var done = function () { el.classList.remove('is-busy'); el.disabled = false; };
    /* Runs as one link on the ordered cart chain, so no other cart mutation can interleave. */
    var p = chain.then(function () {
      var prev = [];
      return fetch(root + 'cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) {
          prev = (c.items || []).map(function (i) {
            var it = { id: i.variant_id || i.id, quantity: i.quantity };
            if (i.properties && Object.keys(i.properties).length) it.properties = i.properties;
            var sp = i.selling_plan_allocation && i.selling_plan_allocation.selling_plan && i.selling_plan_allocation.selling_plan.id;
            if (sp) it.selling_plan = sp;
            return it;
          });
        })
        .catch(function () { prev = []; })
        .then(function () { return cartReq('cart/clear.js', {}); })
        .then(function () {
          var item = { id: Number(variant), quantity: qty };
          if (props) item.properties = props;
          return cartReq('cart/add.js', { items: [item] });
        })
        .then(function () { done(); goCheckout(); })
        .catch(function (err) {
          var put = prev.length ? cartReq('cart/add.js', { items: prev }).catch(function () {}) : Promise.resolve();
          return put.then(function () {
            done();
            note(err && err.message ? err.message : 'Something went wrong. Please try again.');
            open('bag');
          });
        });
    });
    chain = p.then(null, function () {});
  }

  /* ---------- Quiet quick-add (cards, tiles, shop index) ----------
     The press dissolves the bag icon in the same frame (pending). The add is confirmed
     against the micro bs-count section — the server's own count, a few bytes — so the
     check and the badge pop fire as soon as Shopify has the item, and the full drawer
     re-render follows immediately on the same ordered chain. On failure the pill
     restores and the bag opens with the message. */
  function bumpCount() {
    $$('.bs-hd__dot').forEach(function (el) {
      el.classList.remove('is-bump');
      void el.offsetWidth;
      el.classList.add('is-bump');
      setTimeout(function () { el.classList.remove('is-bump'); }, 650);
    });
  }
  function quickAdd(btn, variant, name) {
    if (btn.classList.contains('is-busy') || btn.classList.contains('is-added')) return;
    var pill = btn.classList.contains('bs-qadd');
    var was = pill ? '' : btn.textContent;
    btn.classList.add('is-busy');
    cartOp('cart/add.js', { items: [{ id: Number(variant), quantity: 1 }] }, ['bs-count']).then(function () {
      btn.classList.remove('is-busy');
      btn.classList.add('is-added');
      if (!pill) btn.textContent = 'Added \u2713';
      btn.setAttribute('aria-label', (name || 'Item') + ' added to your bag');
      bumpCount();
      queueRefresh();
      setTimeout(function () {
        btn.classList.remove('is-added');
        if (!pill) btn.textContent = was;
        if (name) btn.setAttribute('aria-label', 'Add ' + name + ' to bag');
      }, 1600);
    }).catch(function (err) {
      btn.classList.remove('is-busy');
      queueRefresh();
      note(err && err.message ? err.message : 'Something went wrong. Please try again.');
      open('bag');
    });
  }

  /* ---------- Discount codes ---------- */
  function codeBox(el) { return el.closest('.bs-code'); }
  function appliedCodes(box) { return ((box && box.dataset.bsCodes) || '').split(',').filter(Boolean); }
  function showCodeMsg(msg, value) {
    $$('.bs-code').forEach(function (box) {
      var t = $('[data-bs-code-toggle]', box), f = $('.bs-code__form', box), m = $('[data-bs-code-msg]', box), i = $('[data-bs-code-input]', box);
      if (t) t.setAttribute('aria-expanded', 'true');
      if (f) f.hidden = false;
      if (i && value) i.value = value;
      if (m) { m.textContent = msg; m.hidden = false; }
    });
  }
  function applyCode(box) {
    var input = $('[data-bs-code-input]', box);
    var code = input ? input.value.trim() : '';
    if (!code) { if (input) input.focus(); return; }
    var existing = appliedCodes(box);
    var all = existing.filter(function (c) { return c.toUpperCase() !== code.toUpperCase(); }).concat([code]);
    busy(box, function () {
      return cartOp('cart/update.js', { discount: all.join(',') }).then(function (j) {
        var dc = (j.discount_codes || []).filter(function (x) { return String(x.code).toUpperCase() === code.toUpperCase(); })[0];
        if (!dc || !dc.applicable) {
          return cartOp('cart/update.js', { discount: existing.join(',') }).then(function () {
            showCodeMsg('This code can’t be applied to your bag.', code);
          });
        }
      });
    });
  }

  /* ---------- Product page ---------- */
  function pdp() {
    $$('[data-bs-pdp]').forEach(function (sec) {
      var q = 1;
      var qv = $('[data-bs-q]', sec), qi = $('[data-bs-qinput]', sec), lt = $('[data-bs-line-total]', sec);
      var price = Number(sec.dataset.price) || 0;
      sec.addEventListener('click', function (e) {
        var s = e.target.closest('[data-bs-step]');
        if (!s) return;
        q = Math.max(1, Math.min(9, q + Number(s.dataset.bsStep)));
        sec.dataset.qty = q;
        if (qv) qv.textContent = q;
        if (qi) qi.value = q;
        if (lt) lt.textContent = inr(price * q);
      });
      var imgs = $$('[data-gi]', sec), dots = $$('.bs-dot', sec);
      if ('IntersectionObserver' in window && dots.length) {
        var io = new IntersectionObserver(function (es) {
          es.forEach(function (en) {
            if (!en.isIntersecting || !isDesk()) return;
            var i = Number(en.target.dataset.gi);
            dots.forEach(function (dot, k) { dot.classList.toggle('is-on', k === i); });
          });
        }, { threshold: 0.35 });
        imgs.forEach(function (im) { io.observe(im); });
      }
      var tr = $('[data-bs-gal]', sec), bar = $('[data-bs-gal-bar]', sec);
      if (tr && bar && imgs.length) {
        tr.addEventListener('scroll', function () {
          var w = tr.clientWidth || 1;
          var i = Math.round(tr.scrollLeft / w);
          bar.style.left = (i * 100 / imgs.length) + '%';
        }, { passive: true });
      }
    });
  }

  /* ---------- You might also like ---------- */
  function ymal() {
    $$('[data-bs-ymal]').forEach(function (sec) {
      var tr = $('[data-bs-ymal-track]', sec);
      var tiles = $$('.bs-tile', sec);
      var prev = $('[data-bs-prev]', sec), next = $('[data-bs-next]', sec), bar = $('[data-bs-ymal-bar]', sec);
      var i = 0;
      tiles.forEach(function (t, k) { t.style.transitionDelay = (k * 0.15) + 's'; });
      var per = function () { return isDesk() ? 3 : 1; };
      var update = function () {
        var p = per();
        var max = Math.max(0, tiles.length - p);
        i = Math.min(i, max);
        var step = tiles[1] ? (tiles[1].offsetLeft - tiles[0].offsetLeft) : 0;
        tr.style.transform = 'translateX(' + (-i * step) + 'px)';
        if (prev) prev.disabled = i <= 0;
        if (next) next.disabled = i >= max;
        if (bar) {
          bar.style.width = (100 * Math.min(p, tiles.length) / tiles.length) + '%';
          bar.style.left = (100 * i / tiles.length) + '%';
        }
      };
      if (prev) prev.addEventListener('click', function () { i = Math.max(0, i - 1); update(); });
      if (next) next.addEventListener('click', function () { i += 1; update(); });
      var x0 = null;
      tr.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      tr.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0;
        if (Math.abs(dx) > 40) { i = Math.max(0, i + (dx < 0 ? 1 : -1)); update(); }
        x0 = null;
      });
      window.addEventListener('resize', update);
      update();
      var reveal = function () {
        sec.classList.add('is-in');
        setTimeout(function () { tiles.forEach(function (t) { t.style.transitionDelay = ''; }); }, 1600);
      };
      if (reduce || !('IntersectionObserver' in window)) { reveal(); return; }
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (en) { if (en.isIntersecting) { reveal(); io.disconnect(); } });
      }, { threshold: 0.25 });
      io.observe(sec);
      setTimeout(reveal, 4000);
    });
  }

  /* ---------- Bag page sticky checkout bar (mobile) ---------- */
  var stickyIO = null;
  function stickyBar() {
    var bar = $('[data-bs-stickybar]'), pay = $('[data-bs-pay]');
    if (stickyIO) { stickyIO.disconnect(); stickyIO = null; }
    if (!bar || !pay || !('IntersectionObserver' in window)) return;
    stickyIO = new IntersectionObserver(function (es) {
      es.forEach(function (en) {
        var on = !en.isIntersecting && en.boundingClientRect.top > 0;
        bar.classList.toggle('is-on', on);
        bar.setAttribute('aria-hidden', on ? 'false' : 'true');
        var b = $('button', bar);
        if (b) b.tabIndex = on ? 0 : -1;
      });
    });
    stickyIO.observe(pay);
  }

  /* ---------- Event delegation ---------- */
  d.addEventListener('click', function (e) {
    var t = e.target.closest('[data-bs-open],[data-bs-open-bag],[data-bs-close],[data-bs-qty],[data-bs-switch],[data-bs-code-toggle],[data-bs-code-apply],[data-bs-code-remove],[data-bs-add],[data-bs-buynow]');
    if (!t) return;

    if (t.hasAttribute('data-bs-open')) {
      e.preventDefault();
      var key = t.dataset.bsOpen;
      /* A dedicated drawer (e.g. the phone menu) opens directly; everything else is cloned into the shared panel. */
      if ($('[data-bs-drawer="' + key + '"]')) open(key);
      else openPanel(key);
      return;
    }

    if (t.hasAttribute('data-bs-open-bag')) {
      if ($('[data-bs-cart-body]')) return; /* already on the bag page */
      if (open('bag')) e.preventDefault();
      return;
    }

    if (t.hasAttribute('data-bs-close')) { e.preventDefault(); close(); return; }

    if (t.hasAttribute('data-bs-qty')) {
      e.preventDefault();
      var line = t.closest('.bs-line');
      if (line && line.classList.contains('is-busy')) return;
      var nm = line ? ($('.bs-line__name', line) || {}).textContent : '';
      var qty = Number(t.dataset.qty);
      /* Pending in the same frame: the line locks and, for a removal, dims.
         The server's re-render is the only thing that changes the contents. */
      if (line) {
        line.classList.add('is-busy');
        if (qty === 0) line.classList.add('is-removing');
      }
      cartOp('cart/change.js', { id: t.dataset.bsQty, quantity: qty }).then(function () {
        note(qty === 0 && nm ? nm.trim() + ' removed.' : '');
      }).catch(function (err) {
        if (line) { line.classList.remove('is-busy'); line.classList.remove('is-removing'); }
        note(err && err.message ? err.message : 'Something went wrong. Please try again.');
      });
      return;
    }

    if (t.hasAttribute('data-bs-switch')) {
      e.preventDefault();
      var updates = {};
      try { updates = JSON.parse(t.dataset.bsSwitch); } catch (err) { return; }
      var nmS = t.dataset.bsSwitchName || 'the set';
      busy(t, function () {
        return cartOp('cart/update.js', { updates: updates }).then(function () { note('Switched to ' + nmS + '.'); });
      });
      return;
    }

    if (t.hasAttribute('data-bs-code-toggle')) {
      e.preventDefault();
      var box = codeBox(t), form = $('.bs-code__form', box);
      var exp = t.getAttribute('aria-expanded') === 'true';
      t.setAttribute('aria-expanded', exp ? 'false' : 'true');
      if (form) form.hidden = exp;
      var msg = $('[data-bs-code-msg]', box);
      if (msg) msg.hidden = true;
      if (!exp) { var inp = $('[data-bs-code-input]', box); if (inp) inp.focus(); }
      return;
    }

    if (t.hasAttribute('data-bs-code-apply')) { e.preventDefault(); applyCode(codeBox(t)); return; }

    if (t.hasAttribute('data-bs-code-remove')) {
      e.preventDefault();
      var bx = codeBox(t), code = t.dataset.bsCodeRemove;
      var rest = appliedCodes(bx).filter(function (c) { return c !== code; });
      busy(bx, function () { return cartOp('cart/update.js', { discount: rest.join(',') }); });
      return;
    }

    if (t.hasAttribute('data-bs-add') || t.hasAttribute('data-bs-buynow')) {
      var sec = t.closest('[data-bs-pdp]');
      var variant = t.dataset.variant || (sec && sec.dataset.variant);
      if (!variant) return;
      e.preventDefault();
      /* Listing quick-adds stay on the page: quiet add, count tick, no drawer. */
      if (!t.hasAttribute('data-bs-buynow') && (t.classList.contains('bs-qadd') || t.classList.contains('ix-add'))) {
        quickAdd(t, variant, t.dataset.name);
        return;
      }
      var q = t.dataset.variant ? 1 : Number((sec && sec.dataset.qty) || 1);
      var name = t.dataset.name || (sec && sec.dataset.name);
      /* Properties (e.g. the pre-order Dispatch line) belong to the main product's form,
         not to the "Want both?" quick-add, which carries its own data-variant. */
      var props = t.dataset.variant ? null : formProps(sec);
      if (t.hasAttribute('data-bs-buynow')) { buyNow(t, variant, q, props); return; }
      addToBag(t, variant, q, name, props);
    }
  });

  d.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') close();
    trapTab(e);
    if (e.key === 'Enter' && e.target.matches && e.target.matches('[data-bs-code-input]')) {
      e.preventDefault();
      applyCode(codeBox(e.target));
    }
  });

  window.addEventListener('pageshow', function (e) { if (e.persisted) refreshBag(); });

  function init() {
    marquee();
    header();
    footer();
    pdp();
    ymal();
    stickyBar();
    ensureCheckoutForm();
  }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', init);
  else init();
})();
